import Vue from 'vue'
import App from './App'
import router from './router'
import mintui from 'mint-ui'
import 'mint-ui/lib/style.css'
import './common.css'
Vue.use(mintui);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js